import React from 'react';
import { Image } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import aiSpark from '../../PINSAISparkIcon.png';

const PINSAISparkIcon = ({ w = '50px', ...props }) => (
  <Image alt="PINS AI Spark Logo" src={aiSpark} width={w} {...props} />
);

PINSAISparkIcon.propTypes = { w: PropTypes.string };

export default PINSAISparkIcon;
